import { Option, TimePeriod } from '@hakimo-ui/hakimo/types';

export const timePeriodOptions: Option<TimePeriod>[] = Object.entries(
  TimePeriod
).map(([id, name]) => ({ id, name }));
